import React, { memo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

import { Typography } from '../../material-ui/Typography';
import { Cell } from './Cell';
import { getPassengerSeats } from '../../../selectors/passengers';
import { useStyles } from './useStyles';
import { usePassengerGridView } from './usePassengerGridView';

export const PassengerGridView = memo(({ isMobile }) => {
    const passengerSeats = useSelector(getPassengerSeats);
    const isPlnCabinExist = passengerSeats && Object.keys(passengerSeats).length > 0;
    const { t: translate } = useTranslation();
    const rowLength = isPlnCabinExist && passengerSeats[Object.keys(passengerSeats)[0]].length;
    const { gridWidth, maxWidth, joinAisleOffset, seatStyle } = usePassengerGridView(rowLength, isMobile);
    const classes = useStyles(maxWidth)();
    const aisleCountRef = useRef(1);

    return (
        <div>
            {!isPlnCabinExist ? (
                <Typography>{translate('messages.noCabinLayoutForAircraft')}</Typography>
            ) : (
                <div className="passenger-grid">
                    {passengerSeats &&
                        Object.keys(passengerSeats).map((rowNumber) => {
                            const row = passengerSeats[rowNumber];
                            aisleCountRef.current = 1;

                            return (
                                <section
                                    key={rowNumber}
                                    className={classnames('passenger-grid__row', classes.row, rowNumber % 2 && classes.secondRow)}
                                >
                                    {row.map((seat, index) => {
                                        const nextSeat = index + 1 < rowLength ? row[index + 1] : null;

                                        return (
                                            <Cell
                                                key={`${seat.row}_${seat.column}`}
                                                cellKey={`${seat.row} ${seat.id} ${seat.name}`}
                                                aisleRef={aisleCountRef}
                                                seat={seat}
                                                nextSeat={nextSeat}
                                                rowLength={rowLength}
                                                gridWidth={gridWidth}
                                                joinAisleOffset={joinAisleOffset}
                                                maxWidth={maxWidth}
                                                seatStyle={seatStyle}
                                            />
                                        );
                                    })}
                                </section>
                            );
                        })}
                </div>
            )}
        </div>
    );
});
